import { render } from "./LocationDetailsSimple.vue?vue&type=template&id=05a80a77&scoped=true"
import script from "./LocationDetailsSimple.vue?vue&type=script&lang=js"
export * from "./LocationDetailsSimple.vue?vue&type=script&lang=js"

import "./LocationDetailsSimple.vue?vue&type=style&index=0&id=05a80a77&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a80a77"]])

export default __exports__